const STORAGE_KEY = 'tbn_dismissed';
const COOKIE_NAME = 'tbn_dismissed';
const COOKIE_DAYS = 7;

function setCookie(name, days) {
    const expires = new Date(Date.now() + days * 864e5).toUTCString();
    document.cookie = `${name}=1; expires=${expires}; path=/; SameSite=Lax`;
}

function isCookieSet(name) {
    return document.cookie.split('; ').some(row => row.startsWith(name + '='));
}

function topBarNotification() {
    const topbar = document.getElementById('topBarNotification');
    if (!topbar) return;

    const topbarclose = document.getElementById('topBarClose');
    const delay    = parseInt(topbar.dataset.delay || '0', 10) * 1000;
    const behavior = topbar.dataset.behavior || 'session';

    const isDismissed = behavior === 'cookie'
        ? isCookieSet(COOKIE_NAME)
        : sessionStorage.getItem(STORAGE_KEY) === '1';

    if (isDismissed) {
        topbar.classList.add('closed');
        return;
    }

    setTimeout(() => topbar.classList.remove('tbn-pending'), delay);

    topbarclose.addEventListener('click', () => {
        topbar.classList.add('closed');
        if (behavior === 'cookie') {
            setCookie(COOKIE_NAME, COOKIE_DAYS);
        } else {
            sessionStorage.setItem(STORAGE_KEY, '1');
        }
    });
}

export default topBarNotification;
